import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "./hooks/useAuth";

/**
 * ProtectedRoute component that checks if the user is authenticated
 * and redirects to the welcome page if not.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render when authenticated
 * @returns {React.ReactNode} - Children or loading component
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Handle redirect if not authenticated
  useEffect(() => {
    // Only run this effect when loading is complete
    if (!loading && !user) {
      console.log("User not authenticated, redirecting to welcome page");

      // Store the attempted URL in session storage to redirect back after login
      sessionStorage.setItem(
        "redirectAfterAuth",
        location.pathname + location.search
      );

      // Redirect to welcome
      //navigate('/onboarding/welcome', { replace: true });
      window.location.href = "/welcome";
    }
  }, [loading, user, navigate, location.pathname, location.search]);

  // Show loading indicator while authentication is being checked
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin w-8 h-8 border-4 border-crimsonGlory border-t-transparent rounded-full"></div>
          <p className="text-gray-600">Checking authentication...</p>
        </div>
      </div>
    );
  }

  // If user is authenticated, render children
  if (user) {
    return children;
  }
  console.log(loading);
  // While redirect is happening, show a loading indicator
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <div className="animate-spin w-8 h-8 border-4 border-crimsonGlory border-t-transparent rounded-full"></div>
        <p className="text-gray-600">Redirecting to login...</p>
      </div>
    </div>
  );
};

export default ProtectedRoute;
